import React, {useEffect, useState} from "react";
import "../../pages/administration/AdministrationPage.css";
import FunctionalTableComponent from "../table/FunctionalTableComponent";
import CustomCard from "../CustomCard";
import {Alert, Col, Row} from "react-bootstrap";
import {Actions} from "../../../client/Actions";
import renderUtils, {getAlarmStatus} from "../../helpers/renderUtils";
import {hasMainPanelAlarmStatusChange} from "../../helpers/jwt";
import { useTranslation } from 'react-i18next';

const AlarmComponent = ({api, title, setLoader}) => {
    const { t } = useTranslation();
    
    const [reload, setReload] = useState(false);
    const [alarms, setAlarms] = useState();
    const [filteredAlarms, setFilteredAlarms] = useState(); // Store filtered alarms
    const [counts, setCounts] = useState({
        CREATED: 0,
        IN_PROGRESS: 0,
        DONE: 0
    });
    const [filters, setFilters] = useState({
        CREATED: true,
        IN_PROGRESS: true,
        DONE: false
    });

    // Get alarm status object with translations
    const alarmStatus = getAlarmStatus(t);

    const onClick = (alarmId, toStatus) => {
        Actions.post("/alarm/" + alarmId, {status: toStatus}, loadAlarms);
    };

    const calculateCounts = () => {
        if (alarms) {
            const result = {CREATED: 0, IN_PROGRESS: 0, DONE: 0};
            alarms.forEach(alarm => {
                if (result.hasOwnProperty(alarm.status)) {
                    result[alarm.status]++;
                }
            });
            setCounts(result);
        }
    };

    const loadAlarms = () => {
        Actions.get(api, data => {
            setAlarms(data);
        });
    };

    // Apply filters and update filteredAlarms whenever alarms or filters change
    useEffect(() => {
        if (alarms && filters) {
            const activeStatuses = Object.keys(filters).filter(status => filters[status]);
            const newFilteredAlarms = activeStatuses.length > 0
                ? alarms.filter(alarm => activeStatuses.includes(alarm.status))
                : [];

            setFilteredAlarms(newFilteredAlarms);
        }

    }, [alarms, filters]);

    const toggleFilter = (status) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            [status]: !prevFilters[status]
        }));
    };

    useEffect(loadAlarms, []);
    useEffect(calculateCounts, [alarms]);

    const renderStatusLabel = (status, count) => {
        const statusInfo = alarmStatus[status];
        const defaultClassName = "font-max mr-2";

        return statusInfo ? (
            <span className={`${statusInfo.className} ${defaultClassName}`}>
                {`${statusInfo.label}${count ? ` (${count})` : ""}`}
            </span>
        ) : (
            t("common.unknown_status")
        );
    };

    const alarmColumn = {
        field: "alarm",
        sort: "desc",
        width: 500,
        type: "custom",
        custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
            return <Alert variant={alarmStatus[row.status].variant} className={"shadow"}>
                <div className={"d-flex justify-content-between align-items-center "}>
                    <div className={"d-block mr-2 text-break"}>
                        <p className={""}><strong>{row.title}</strong></p>
                        <span>{row.content}</span>
                    </div>
                    <div className={"d-flex"}>
                        {renderUtils.renderAlarmDate(row.status, row.creationDate, t)}
                        {renderUtils.renderAlarmStatus(row.status, undefined, t)}
                        {hasMainPanelAlarmStatusChange() &&
                            renderUtils.renderAlarmStatusButton(row.status, (toStatus) => onClick(row.id, toStatus), t)
                        }
                    </div>
                </div>
            </Alert>
        }
    };

    return (
        <Col md={8}>
            <Row>
                <CustomCard titleComponent={
                    <div className={"d-flex justify-content-between"}>
                        <span className={"text-primary font-weight-bold"}>{t("menu.alarms")}</span>
                        <div className={"d-flex justify-content-between"}>
                            <span
                                onClick={() => toggleFilter("CREATED")}
                                className={`status-filter ${filters.CREATED ? 'active' : ''}`}
                                style={{cursor: "pointer"}}
                            >
                                {renderStatusLabel("CREATED", counts.CREATED || "0")}
                            </span>
                            <span
                                onClick={() => toggleFilter("IN_PROGRESS")}
                                className={`status-filter ${filters.IN_PROGRESS ? 'active' : ''}`}
                                style={{cursor: "pointer"}}
                            >
                                {renderStatusLabel("IN_PROGRESS", counts.IN_PROGRESS || "0")}
                            </span>
                            <span
                                onClick={() => toggleFilter("DONE")}
                                className={`status-filter ${filters.DONE ? 'active' : ''}`}
                                style={{cursor: "pointer"}}
                            >
                                {renderStatusLabel("DONE", counts.DONE || "0")}
                            </span>
                        </div>
                    </div>
                } hideBody={true} width={12}/>
            </Row>
            <Row>
                {filteredAlarms
                && filteredAlarms.length > 0 ? <FunctionalTableComponent
                        className={"mt-1 no-padding-table"}
                        title={title}
                        columns={[alarmColumn]}
                        header={false}
                        setLoader={setLoader}
                        readOnly={false}
                        removable={false}
                        editable={false}
                        width={12}
                        initialData={filteredAlarms} // Use filtered alarms
                        externalReload={reload}
                        tableHeader={false}
                        pagination={true}
                        noCard={true}
                    /> :
                    <span className={"ml-4"}>{t("common.none")}</span>}
            </Row>
        </Col>
    );
};

export default AlarmComponent;
